import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()

export class ChangePasswordService extends SecurityService {

    constructor(http: HttpClient, configService: ConfigService, eventsEmitterService: EventsEmitterService, router: Router, logger: LogService) {
        super(http, configService, eventsEmitterService, router, logger);
    }

    public changePasswordRequest(pwd){
        let serviceUrl = this.baseUrl + 'OnBoardService/changePassword';
        return this.http.post<any>(serviceUrl,pwd).pipe(map(response => {return response;}));
    }

    public updatePasswordRequest(pwd){
        let serviceUrl = this.baseUrl + 'RegistrationService/updatePassword';
        return this.http.post<any>(serviceUrl,pwd).pipe(map(response => {return response;}));
    }

    getRules(): Observable<any> {        
        let serviceUrl = this.baseUrl + 'LoginService/rules';
        return this.http.get(serviceUrl).pipe(map(super.extractData),catchError(super.handleError));
    }
}